import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getModules } from "./redux/customChartSagas";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import ActionsFilter from "./smartComponents/Actions";
import { Delete } from "./smartComponents/Delete";
import { Edit } from "./smartComponents/Edit";
import { Add } from "./smartComponents/Add";
import GoogleStackedBarChart from "../../components/googleChart/googleChart";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import { usePopup } from "./hooks/usePopup";
import "./customCharts.scss";

function scrollToModuleById(id) {
  const element = document.querySelector(`.chart-${id}`);
  if (element) {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.scrollY || window.pageYOffset;
    const targetY = rect.top + scrollTop;

    window.scrollTo({
      top: targetY
    });
  }
}

export const CustomChartsModule = () => {
  const dispatch = useDispatch();
  const modules = useSelector((state) => state.customCharts.modules);
  const isLoading = useSelector((state) => state.customCharts.isLoading);

  const { popup, openPopup, closePopup } = usePopup();
  const [selectedModule, setSelectedModule] = useState("");

  const moduleIdToScroll = useRef(null);

  const handlePopup = (id, type) => {
    setSelectedModule(modules.find((module) => module.id == id));
    openPopup(type);
  };

  useEffect(() => {
    dispatch(getModules());
  }, []);

  useEffect(() => {
    if (moduleIdToScroll.current) {
      requestAnimationFrame(() => {
        scrollToModuleById(moduleIdToScroll.current);
        moduleIdToScroll.current = null;
      });
    }
  }, [modules]);

  return (
    <div className="custom-charts ">
      <button onClick={() => openPopup("add")} title="Add new chart" className="add-button">
        Add new chart
      </button>
      {isLoading ? (
        <LoadingAnimation />
      ) : (
        modules?.map((module) => {
          const {
            id,
            name,
            position,
            graph_type,
            chart: {
              data_table: { cols = [], rows = [] },
              options
            }
          } = module;
          return (
            <SectionToggle
              key={id}
              maxHeight="auto"
              autoHeight
              title={name}
              isLoading={false}
              customClass={`chart-${id}`}
              content={
                <div>
                  <div className="top-filters">
                    <ActionsFilter
                      position={position}
                      moduleId={id}
                      openPopup={(type) => handlePopup(id, type)}
                      moduleIdToScroll={moduleIdToScroll}
                    />
                  </div>
                  <GoogleStackedBarChart
                    width="1350px"
                    height={400}
                    chartType={graph_type}
                    rows={rows}
                    columns={cols}
                    key={graph_type}
                    options={options}
                  />
                </div>
              }
            />
          );
        })
      )}
      {popup.add && <Add isOpen={popup.add} onClose={closePopup("add")} />}
      {popup.delete && (
        <Delete
          isOpen={popup.delete}
          onClose={closePopup("delete")}
          selectedModule={selectedModule}
        />
      )}
      {popup.edit && (
        <Edit isOpen={popup.edit} onClose={closePopup("edit")} selectedModule={selectedModule} />
      )}
    </div>
  );
};

export default CustomChartsModule;
